import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import calcService from "data/calc"
// components
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
// lib
import propertyService from 'data/property'
// styles
import { Label_s } from 'styles/app-styles'
import DataTable_s from 'components/table/data-table-styles'
import { MarketLeaseGrid_s } from 'components/property/reports/report-styles'

interface OccupancyAreaTableProps {
  data: object[],
  selected: object[],
  setSelected: Function,
  disableRunBtn: Function
}

const OccupancyAreaTable: FC<OccupancyAreaTableProps> = (props) => {
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  
  useEffect(() => {
    setPropertyId(propertyService.getStoredPropertyId());
    if (_.isNil(propertyId)) return
  }, [propertyService.getStoredPropertyId()])
  
  return (
    <MarketLeaseGrid_s>
      <Label_s>Area Measures</Label_s>
      <DataTable_s>
        <DataTable
          value={props.data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          emptyMessage="No records found"
          selection={props.selected}
          onSelectionChange={(e)=>props.setSelected(e.value)}
        >
          <Column selectionMode="multiple" style={{width: '20px'}} />
          <Column field="code" header="Code" sortable={true} style={{width: '225px'}} />
          <Column field="name" header="Name" sortable={true} style={{width: '225px'}} />
        </DataTable>
      </DataTable_s>
    </MarketLeaseGrid_s>
  )
}

export default OccupancyAreaTable
